
import React from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import HeroSection from '@/components/HeroSection';
import FeaturedTracksCarousel from '@/components/FeaturedTracksCarousel'; 
import FeatureSection from '@/components/FeatureSection';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Index: React.FC = () => {
  // Function to scroll to top on navigation
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow">
        <HeroSection />
        
        {/* Featured Tracks Carousel */}
        <div className="py-8 -mt-24 bg-background">
          <div className="container px-4 mx-auto">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-6 text-white text-center featured-tracks-title" style={{ color: "white" }}>
              Featured Tracks
            </h2>
            <FeaturedTracksCarousel />
          </div>
        </div>
        
        {/* How It Works Section */}
        <FeatureSection />
        
        {/* CTA Section */}
        <div className="py-20 bg-accent/20 text-foreground">
          <div className="container px-4 mx-auto text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-6">
                Ready to boost your Spotify presence?
              </h2>
              <p className="text-lg mb-8 text-muted-foreground">
                ⭐ Start rewarding fans and grow your music career with every download.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link to="/register" onClick={scrollToTop}>
                  <Button 
                    size="lg" 
                    variant="default" 
                    className="w-full sm:w-auto group"
                  >
                    Start My FREE Trial
                    <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
